export const handleOpenInLayer = (url, withFefa, enableDeepLinking, customData) => {
    try {
        const currentUrl = new URL(window.location.href);
        if (withFefa) {
            currentUrl.searchParams.append('withFefa', 'true');
        }
        if (enableDeepLinking) {
            const hashParams = new URLSearchParams();
            const decodedUrl = decodeURIComponent(url);
            hashParams.append('one-layer', decodedUrl);
            const updatedHash = Array.from(hashParams.entries()).map(([key, value]) => `${key}=${value}`);
            currentUrl.hash = updatedHash.toString();
        }
        if (enableDeepLinking || withFefa)
            window.history.pushState({}, '', currentUrl.toString());
        const eventData = {
            url: enableDeepLinking ? '' : url,
            customData: customData || null,
        };
        const event = new CustomEvent('hashchange', {
            detail: eventData,
        });
        window.dispatchEvent(event);
    }
    catch {
        throw new Error('Something went wrong while opening the layer.');
    }
};
//# sourceMappingURL=index.js.map